var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7278 17.2497C13.953 19.0245 9.4079 17.3569 5.576 13.525C1.74411 9.69307 0.0764765 5.14797 1.85124 3.37319L3.0198 2.20464C3.82651 1.39792 5.15578 1.41925 5.9888 2.25227L7.79879 4.06225C8.63181 4.89527 8.65313 6.22454 7.84642 7.03126L7.59542 7.28225C7.15987 7.71781 7.11726 8.42045 7.52197 8.91089C7.91234 9.38395 8.3332 9.85514 8.78951 10.3115C9.24582 10.7678 9.71702 11.1886 10.1901 11.579C10.6805 11.9837 11.3832 11.9411 11.8187 11.5055L12.0697 11.2546C12.8764 10.4478 14.2057 10.4692 15.0387 11.3022L16.8487 13.1122C17.6817 13.9452 17.703 15.2745 16.8963 16.0812L15.7278 17.2497Z",
    fill: "#1F2024",
    stroke: "#1F2024",
    strokeWidth: 1.36219
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.0b507ee3b2fd399792eae896ca6bae6e.svg";
export { ForwardRef as ReactComponent };